import React, { useState } from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon, FileFieldIcon } from '../../_components'
import { FaBuilding, FaAddressCard, FaUserAlt } from 'react-icons/fa'
import data from '../../fixtures'
import { useDispatch, useSelector } from 'react-redux'
import { setSectionAData, setLocationProofFiles } from '../../_slices/AppSlice'
import Axios from 'axios'
import { handleFileChange } from '../../_utils'

export default function SectionC( { handleChange, handleBlur, values, signing } ) {
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      sectionAData: state.application.sectionAData,
      locationProofFiles: state.application.locationProofFiles,
    }
  } )
  const [countyOptions, setCountyOptions] = useState([]);
  const [subcountyOptions, setSubcountyOptions] = useState([]);
  const [parishOptions, setParishOptions] = useState([]);
  const [villageOptions, setVillageOptions] = useState([]);

  const [ uploadedLocationProofFiles, setUploadedLocationProofFiles ] = useState( {} )

  const handleChangeTradingName = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, trading_name: evt.target.value} ) );
  }

  const handleChangeDistrict = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, district: evt.target.value} ) );

    const selectedDistrict = evt.target.value
    //data.counties
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_counties/${selectedDistrict}`);

      if( response.data.message === "success" ) {
        //console.log(response.data.district_counties)
        let dbcounties = response.data.district_counties
        let districtcounties = dbcounties.map((item) => ({ id: item.id, label: item.name, value: item.name }));
        setCountyOptions(districtcounties)
      } else{
        console.log("response returned error")
        console.log(response.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeCounty = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, county: evt.target.value} ) );

    const selectedCounty = evt.target.value
    //data.counties
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_subcounties/${selectedCounty}`);

      if( response.data.message === "success" ) {
        //console.log(response.data.county_subcounties)
        let dbsubcounties = response.data.county_subcounties
        let county_subcounties = dbsubcounties.map((item) => ({ id: item.id, label: item.name, value: item.name }));
        setSubcountyOptions(county_subcounties)
      } else{
        console.log("response returned error")
        console.log(response.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeSubCounty = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, subcounty: evt.target.value} ) );

    const selectedSubcounty = evt.target.value
    //data.counties
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_parishes/${selectedSubcounty}`);

      if( response.data.message === "success" ) {
        //console.log(response.data.subcounty_parishes)
        let dbparishes = response.data.subcounty_parishes
        let subcounty_parishes = dbparishes.map((item) => ({ id: item.id, label: item.name, value: item.name }));
        setParishOptions(subcounty_parishes)
      } else{
        console.log("response returned error")
        console.log(response.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeParish = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, parish: evt.target.value} ) );

    const selectedParish = evt.target.value
    //data.counties
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_villages/${selectedParish}`);

      if( response.data.message === "success" ) {
        //console.log(response.data.parish_villages)
        let dbvillages = response.data.parish_villages
        let parish_villages = dbvillages.map((item) => ({ id: item.id, label: item.name, value: item.name }));
        setVillageOptions(parish_villages)
      } else{
        console.log("response returned error")
        console.log(response.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeVillage = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, village: evt.target.value} ) );
  }

  const handleChangeLocationProof = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, location_proof: evt.target.value} ) );
  }

  const handleChangeServiceType = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, service_type: evt.target.value} ) );
  }

  const handleChangeSpecifyService = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, specify_service: evt.target.value} ) );
  }

  const handleChangeWebsite = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, website: evt.target.value} ) );
  }

  const handleChangeAnnualTurnOver = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, annual_turnover: evt.target.value} ) );
  }

  const handleChangeCompanyCertification = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, company_certification: evt.target.value} ) );
  }

  const handleChangeMembership = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, membership: evt.target.value} ) );
  }

  const handleChangeSpecifyMembership = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, specify_membership: evt.target.value} ) );
  }

  const handleChangeNumberMales = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, no_males: evt.target.value} ) );
  }

  const handleChangeNumberFemales = async (evt) => {
    await dispatch( setSectionAData( {...state.sectionAData, no_females: evt.target.value} ) );
  }

  const handleFile = ( evt, tag ) => {
    handleFileChange( evt, tag, (response, file ) => {
      if(file.size > 6128180){
        alert("Please make sure that the file size doesn't exceed 5 MBs")
      } else{
        setUploadedLocationProofFiles( {
          document: response,
          name: file.name,
          size: file.size,
          tag,
          type: file.type
        })
      }
    })
  }

  const handleFileBlur = (evt) => {
    let savedFile = { 
      file: uploadedLocationProofFiles.document, 
      title: uploadedLocationProofFiles.name, 
      size: uploadedLocationProofFiles.size, 
      type: uploadedLocationProofFiles.type, 
    }

    let data = Object.assign( {}, savedFile )

    dispatch(  setLocationProofFiles( {locationProofFiles: [ ...state.locationProofFiles, data ] }) )
  }

  return (
    <>
      <Panel label={`Section C: Business Details - ${values.category?.toUpperCase()}`}>
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
            <TextFieldIcon 
              name="trading_name"
              handleChange={evt => {
                handleChange(evt)
                handleChangeTradingName( evt)
              }}
              handleBlur={handleBlur}
              value={values.trading_name}
              iconComponent={<FaAddressCard color={`#AFC836`} />} 
              label="Business/Trading Name"
              required={true}
              disabled={signing}
              question="Business/Trading Name" />
          </div>
      </Panel>

      <Panel label={`Section C: Business Details - Location Details`}>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2 mb-5">
          <SelectFieldIcon 
            name="district"
            handleChange={evt => {
              handleChange(evt)
              handleChangeDistrict( evt)
            }}
            handleBlur={handleBlur}
            value={values.district}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="District"
            required={values.entity_registration === "No" ? false : true}
            disabled={signing}
            options={data.districts.map( ( { id, name } ) => {
              return { 
                id, 
                label: name, 
                value: name }
            } )}
            question="District" />

            <SelectFieldIcon 
            name="county"
            handleChange={evt => {
              handleChange(evt)
              handleChangeCounty( evt)
            }}
            handleBlur={handleBlur}
            value={values.county}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="County"
            required={values.entity_registration === "No" ? false : true}
            disabled={signing}
            options={countyOptions.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="County /Municipality" />
          
          <SelectFieldIcon 
            name="subcounty"
            handleChange={evt => {
              handleChange(evt)
              handleChangeSubCounty( evt)
            }}
            handleBlur={handleBlur}
            value={values.subcounty}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Subcounty"
            required={values.entity_registration === "No" ? false : true}
            disabled={signing}
            options={subcountyOptions.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="Sub-county / Division" />
          
          <SelectFieldIcon 
            name="parish"
            handleChange={evt => {
              handleChange(evt)
              handleChangeParish( evt)
            }}
            handleBlur={handleBlur}
            value={values.parish}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Parish"
            required={values.entity_registration === "No" ? false : true}
            disabled={signing}
            options={parishOptions.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="Parish/Ward" />
          
          <SelectFieldIcon 
            name="village"
            handleChange={evt => {
              handleChange(evt)
              handleChangeVillage( evt)
            }}
            handleBlur={handleBlur}
            value={values.village}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Village"
            required={values.entity_registration === "No" ? false : true}
            disabled={signing}
            options={villageOptions.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="Village" />
          
          <SelectFieldIcon 
            name="location_proof"
            handleChange={evt => {
              handleChange(evt)
              handleChangeLocationProof( evt)
            }}
            handleBlur={handleBlur}
            value={values.location_proof}
            iconComponent={<FaBuilding color={`#AFC836`} />} 
            label="Proof of Location"
            required={true}
            disabled={signing}
            options={data.proofs.map( ( { id, label, value } ) => {
              return { id, label, value }
            } )}
            question="Proof of Location" />

            <FileFieldIcon
              noPadding
              name="attach_proof"
              handleBlur={evt => {
                handleBlur(evt)
                handleFileBlur( evt )
              }}
              //value={values?.attach_proof}
              handleChange={evt => {
                handleChange(evt)
                handleFile( evt, "attached_proof" )
              }}
              iconComponent={<FaUserAlt color={`#666`} />}
              label="Attach Proof Document (Less than 5MB)"
              question={`${values.location_proof} Document (Less than 5MB)`} 
              required={true} 
            />

          {values.entity_registration === "No" &&
            <TextFieldIcon 
            name="physical_address"
            handleChange={evt => {
              handleChange(evt)
              handleChangeTradingName( evt)
            }}
            handleBlur={handleBlur}
            value={values.physical_address}
            iconComponent={<FaAddressCard color={`#AFC836`} />} 
            label="Physical Address"
            required={false}
            disabled={signing}
            question="Physical Address" />
          }
        </div>
      </Panel>

      <Panel label={`Section C: `}>
          <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
            {/* <SelectFieldIcon 
              name="service_type"
              handleChange={evt => {
                handleChange(evt)
                handleChangeServiceType( evt)
              }}
              handleBlur={handleBlur}
              value={values.service_type}
              iconComponent={<FaBuilding color={`#AFC836`} />} 
              label=""
              required={true}
              disabled={signing}
              options={data.servicetypes.map( ( { id, label, value } ) => {
                return { id, label, value }
              } )}
              question="Type of Services Offered" /> */}

              { values.service_type === "Other" && (
                 <TextFieldIcon 
                 name="specify_service"
                 handleChange={evt => {
                  handleChange(evt)
                  handleChangeSpecifyService( evt)
                }}
                 handleBlur={handleBlur}
                 value={values.specify_service}
                 iconComponent={<FaAddressCard color={`#AFC836`} />} 
                 label="Specify Other Service"
                 required={values.service_type === "Other" && true}
                 disabled={signing}
                 question="Specify Other Service Offered" />
              )}
            
            <TextFieldIcon 
              name="website"
              handleChange={evt => {
                handleChange(evt)
                handleChangeWebsite( evt)
              }}
              handleBlur={handleBlur}
              value={values.website}
              iconComponent={<FaAddressCard color={`#AFC836`} />} 
              label="Website"
              required={false}
              disabled={signing}
              question="Website" />
            
            {/* <TextFieldIcon 
              name="annual_turnover"
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values.annual_turnover}
              iconComponent={<FaAddressCard color={`#AFC836`} />} 
              label="Annual Turnover / Income"
              required={true}
              disabled={signing}
              question="Annual Turnover for the Previous Year" /> */}
            <SelectFieldIcon 
              name="annual_turnover"
              handleChange={evt => {
                handleChange(evt)
                handleChangeAnnualTurnOver( evt)
              }}
              handleBlur={handleBlur}
              value={values.annual_turnover}
              iconComponent={<FaBuilding color={`#AFC836`} />} 
              label="Annual Turnover / Income"
              required={true}
              disabled={signing}
              options={data.turnover.map( ( { id, label, value } ) => {
                return { id, label, value }
              } )}
              question="Annual Turnover/Income for the Previous Year" />
            
            <TextFieldIcon 
              name="company_certification"
              handleChange={evt => {
                handleChange(evt)
                handleChangeCompanyCertification( evt)
              }}
              handleBlur={handleBlur}
              value={values.company_certification}
              iconComponent={<FaAddressCard color={`#AFC836`} />} 
              label="Company Certification"
              required={false}
              disabled={signing}
              question="Company Certification" />
            
            <SelectFieldIcon 
              name="membership"
              handleChange={evt => {
                handleChange(evt)
                handleChangeMembership( evt)
              }}
              handleBlur={handleBlur}
              value={values.membership}
              iconComponent={<FaBuilding color={`#AFC836`} />} 
              label="Membership"
              required={false}
              disabled={signing}
              options={data.membership.map( ( { id, label, value } ) => {
                return { id, label, value }
              } )}
              question="Membership to I.T Professional bodies" />

            {values.membership === "Other" && (
              <TextFieldIcon 
                name="specify_membership"
                handleChange={evt => {
                  handleChange(evt)
                  handleChangeSpecifyMembership( evt)
                }}
                handleBlur={handleBlur}
                value={values.specify_membership}
                iconComponent={<FaAddressCard color={`#AFC836`} />} 
                label="Specify Membership"
                required={values.membership === "Other"  && true}
                disabled={signing}
                question="Specify Other Membership" />
            )}
            
            {values.category !== "Individual"  && (
              <TextFieldIcon 
                type="number"
                name="no_males"
                handleChange={evt => {
                  handleChange(evt)
                  handleChangeNumberMales( evt)
                }}
                handleBlur={handleBlur}
                value={values.no_males}
                iconComponent={<FaAddressCard color={`#AFC836`} />} 
                label="# Males"
                required={true}
                disabled={signing}
                question="Number of Employees( MALES )" />)
            }
            
            {values.category !== "Individual" && (
              <TextFieldIcon 
                type="number"
                name="no_females"
                handleChange={evt => {
                  handleChange(evt)
                  handleChangeNumberFemales( evt)
                }}
                handleBlur={handleBlur}
                value={values.no_females}
                iconComponent={<FaAddressCard color={`#AFC836`} />} 
                label="# Females"
                required={true}
                disabled={signing}
                question="Number of Employees( FEMALES )" />)
            }
          </div>
      </Panel>


    </>
  )
}
